import React from 'react'

import './instructions.css'
import { instructions } from './instructions-data'

const Instructions = () => {
  return (
    <div className='col-md-12 no-gutters instructionslist mb-3 py-2 ps-2 whitebg shadow font-12 sourcesanspro text-color5 bordered7 border-radius '>
        <ul aria-live='polite' tabIndex={0}>
          {instructions.map((items) => (
            <li className='mb-2' key={items.title}>
              <span aria-label={items.title} tabIndex={0}>
                {items.title}
              </span>
            </li>
          ))}
        </ul>
      </div>
  )
}
export default Instructions
